import { Injectable } from "@angular/core";
import { CommonService } from "../../services/common.service";
import { ActivatedRoute, Router } from "@angular/router";
import { BehaviorSubject } from "rxjs";


@Injectable({
    providedIn: 'root'
  })
export class SearchService {
    search_term:string='';

    is_search_clicked = new BehaviorSubject(false);
    all_search_terms: any;
    show_filter_button = false;
    dropdowns: any;

    constructor(private commonservice:CommonService, private router:Router, private activatedRoute: ActivatedRoute) {
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
     }
    url:any

    reset() {
        this.is_search_clicked.next(false);
        this.all_search_terms = {};
        this.show_filter_button = false;
        this.dropdowns = [];
        this.search_term='';
        this.commonservice.video_data={};
        this.router.navigate(['/home'])
        // this.activatedRoute.url.subscribe((url:any) =>{
        //     this.url=url.path;
        // })

        // this.router.navigate(['/search'], { skipLocationChange: true });

    }

}